import styled from 'styled-components';

export const Container = styled.div`
  .profile-image {
    width: 50px;
    height: 50px;
    margin: 0 auto;
    background-size: cover;
    background-color: #eaeaea;
    background-position: center;
    border-radius: 100px;
  }

  .box-header {
    display: flex;
    align-items: center;

    .filter {
      margin-right: 20px;

      & > div {
        display: flex;
        flex-direction: column;
      }

      input {
        margin-bottom: 0;
        margin-top: 10px;
      }
    }

    @media (max-width: 991px) {
      display: grid;
      grid-template-columns: 33% 33% 33%;
      row-gap: 10px;

      .filter {
        & > div {
          float: none;
        }
      }
    }

    @media (max-width: 600px) {
      grid-template-columns: 100%;
    }
  }

  .instagram-input {
    min-width: 200px;
  }
  .followers-input {
    min-width: 105px;
  }

  .invite-promoter-container {
    display: flex;
    align-items: center;
    margin-bottom: 20px;

    .subtitle {
      font-size: 18px;
    }

    & > * {
      margin-right: 15px;
    }

    @media (max-width: 600px) {
      flex-direction: column;
      align-items: baseline;
    }
  }
`;

export const Filter = styled.div`
  float: right;
  font-size: 14px;
  color: #a7b3bb;

  span {
    margin-right: 10px;
  }
`;

export const Table = styled.table`
  text-align: center;
  margin-bottom: 0;

  td,
  th {
    vertical-align: middle;
  }

  .btn-small {
    padding: 1px 7px;
    font-size: 12px;
    margin: 0 5px;
  }

`;

export const Paginate = styled.div`
.pagination a {
  color: black;
  float: left;
  padding: 8px 16px;
  text-decoration: none;
  cursor: Pointer;
}
.active {
    background-color: #000;
    a {
      color: #fff;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/admin/pages/Promoters/styles.js